import React, { useState, useEffect, Children } from "react";
const CardStatBranchContent = ({ id, top, last }) => {
    useEffect(() => {
        return () => {};
    }, [top, last]);

    return (
        <div className="card mb-1 h-100">
            <div className="card-body text-dark">
                <div className="row mt-2">
                    <div className="col">
                        <span className="text-danger mr-1">최고 사용량:</span>
                        {top ? top.branchName : "-"}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <span className="text-primary mr-1">최저 사용량:</span>
                        {last ? last.branchName : "-"}
                    </div>
                </div>
            </div>
        </div>
    );
};
const CardStatContent = ({ id, title, titleBgClass = "", children }) => {
    useEffect(() => {
        return () => {};
    }, [title, children]);

    return (
        <div className={`card mb-1 h-100`} style={{}}>
            <div className={`card-header stat-content ${titleBgClass}`}>{title}</div>
            <div className="card-body text-dark p-3">{children ? children : <></>}</div>
        </div>
    );
};

export { CardStatContent as default, CardStatBranchContent };
